import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  addButtonLabel: {
    id: 'contactPersonform.button.add.label',
    description: 'Label for contact person form add button',
    defaultMessage: 'Add',
  },
  cancelButtonLabel: {
    id: 'contactPersonForm.button.cancel.label',
    description: 'Label for contact person form cancel button',
    defaultMessage: 'Cancel',
  },
  updateButtonLabel: {
    id: 'contactPersonForm.button.update.label',
    description: 'Label for contact person form update button',
    defaultMessage: 'Save',
  },
});
